module.exports = __webpack_public_path__ + "2022426:23e21cd641c426082ae7/img/HomeScreen-Devices-S.1c44e60.png";